export class MatchModel {
  userId = 1;
  firstName = '';
  lastName = '';
  profilePicUrl?: string;
  isSuspended: 1 | 0 = 0;
  isBlocked: 1 | 0 = 0
}
